import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";

export const renderStatisticsIcon = (hasStatistics: boolean, statisticsTooltip: string, statHandler: React.MouseEventHandler) => {
    return (
        hasStatistics
            ? <EventCardIcon className="rj-ev-list__ev-card-icon--tooltip rj-ev-list__ev-card-icon--hidden-on-mobile"
                tooltip={statisticsTooltip}
                onClick={statHandler}>
                <Icon i="i-24-16 i-o-ev-statistics" />
            </EventCardIcon>
            : createEmptyTooltipIcon()
    )
}